import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function getCityManifest (cityId)
{
    let url = urljoin(ServicesUtils.apiUrl, `cities/${cityId}/manifest`)
    const response = await axios.get(url)

    return response.data
}

export default { getCityManifest }


// WEBPACK FOOTER //
// ./src/services/cities.js